<template>
  <div>
    <div
      v-if="section"
      class="link-container my-2"
    >
      <div class="table-sub-class text-sm">
        <span
          class="link-class clickable"
          style="font-size:13px !important;"
          @click="goBack"
        >
          {{ section | capitalize }}
        </span>
        <span>/ {{ subSection | capitalize }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="d-flex align-items-center">
          <!-- Title -->
          <div class="top-text">
            {{ title }}
          </div>

          <!-- Count Badge -->
          <b-badge v-if="count" class="ml-3" variant="info">
            {{ count.toLocaleString() }}
          </b-badge>

          <!-- Title After -->
          <slot name="title__after"></slot>
        </div>
        <div class="medium-bold">
          {{ subTitle }}
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end mb-4">
        <!-- Status Summary -->
        <slot name="status"></slot>

        <!-- Actions -->
        <slot name="actions"></slot>

        <!-- Filters -->
        <slot name="filters"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.link-container {
  height: 18px;
}

.badge {
  font-size: 16px;
}

.top-text {
  font-size: 26px;
  font-weight: 500;
}
</style>

<script>
export default {
  name: "TopSection",
  props: [
    "title",
    "subTitle",
    "tooltip",
    "tags",
    "count",
    "section",
    "subSection",
    "backSection"
  ],
  methods: {
    goBack () {
      console.log("going back to " + this.backSection)
      if (this.backSection){
        this.$router.push({ "name": this.backSection })
      }
      else{
        this.$router.go(-1)
      }
    }
  }
}
</script>
